import parseJwt from "./parseJwt";
import getCookie from "./getCookie";

/**
 * [isLoggedIn Checks if a user is logged in. IMPORTANT: This method only check if there is an unexpired cookie.
   It does not validate it as there aren't any authorized endpoints. Once an authorized endpoint is integrated into this project update this to an API call]
 * @param  {String} key
 * @return {Object} Returns an object containing logged in state & fyers id
 */
export default function isLoggedIn() {
  const fyersCookie = getCookie("_FYERS");
  let loginDetails = { loggedIn: false, fy_id: "" };
  if (fyersCookie) {
    const parsedCookie = parseJwt(fyersCookie);
    if (parsedCookie.fy_id && parsedCookie.exp > new Date().getTime() / 1000) {
      loginDetails.loggedIn = true;
      loginDetails.fy_id = parsedCookie.fy_id;
    }
  }
  return loginDetails;
}
